export default __webpack_public_path__ + "static/media/lato-bold.249100de.svg";